import { media } from '@simplywallst/ui-core';
import styled, { css } from 'styled-components';

const iconStyle = css`
  width: ${({ theme }) => theme.x6spacePx - 2}px;
  height: ${({ theme }) => theme.x6spacePx - 2}px;
  min-width: ${({ theme }) => theme.x6spacePx - 2}px;
  min-height: ${({ theme }) => theme.x6spacePx - 2}px;
  border: 1px solid ${({ theme }) => theme.color.white};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  object-fit: scale-down;
  vertical-align: text-bottom;
  ${media.lgUp`
      width: ${({ theme }) => theme.x6spacePx + 8}px;
      height: ${({ theme }) => theme.x6spacePx + 8}px;
      min-width: ${({ theme }) => theme.x6spacePx + 8}px;
      min-height: ${({ theme }) => theme.x6spacePx + 8}px;
  `}
`;

export const StyledImg = styled('img')`
  ${iconStyle}
`;

export const FallbackDiv = styled('div')`
  ${iconStyle}
`;

export const FallbackSvg = styled('svg')`
  ${iconStyle}

  text {
    color: #fff;
    line-height: 1;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
  }
`;
